/* eslint-disable no-return-assign */
/* eslint-disable react/button-has-type */
import React from 'react';
import CanvasDraw from 'react-canvas-draw';

import { applyPainMapDotFix } from '@mummssoftware/utils/utils';

import painMapGif from '../images/pain.gif';
import { PainMapCanvas } from './WrapperDiv';

type PainMapProps = {
  handleValidate?: (event: any) => void;
  handleClear?: () => void;
  readOnly?: boolean;
  subqchoice: any;
};

interface PainMapState {
  brushColor: string;
  validated: boolean;
}

// Class as savedData not working with func component
class PainMap extends React.PureComponent<PainMapProps, PainMapState> {
  saveableCanvas: any;

  loadableCanvas: any;

  constructor(props: PainMapProps) {
    super(props);
    this.state = {
      brushColor: 'black',
      validated: false,
    };
  }

  onClear = () => {
    if (this.props.handleClear) {
      this.props.handleClear();
      this.saveableCanvas.eraseAll();
    }
  };

  onUndo = () => this.saveableCanvas.undo();

  onValidate = () => {
    if (this.props.handleValidate) {
      this.setState({
        validated: true,
      });
      const data = this.saveableCanvas.getSaveData();
      if (data) {
        // todo REMOVE local storage
        localStorage.setItem('savedDrawing', data);
        this.props.handleValidate(data);
      }
    }
  };

  render() {
    const { subqchoice } = this.props;
    // CanvasDraw expects a string
    const savedData =
      subqchoice && subqchoice.value !== 'false'
        ? JSON.stringify(subqchoice.value)
        : undefined;

    return (
      <div id="pain-map-wrapper">
        <div id="pain-map-actions">
          <button onClick={this.onValidate} disabled={this.props.readOnly}>
            Validate
          </button>
          <button onClick={this.onClear} disabled={this.props.readOnly}>
            Clear
          </button>
          <button onClick={this.onUndo} disabled={this.props.readOnly}>
            Undo
          </button>
        </div>
        <PainMapCanvas id="pain-map-canvas" validated={this.state.validated}>
          <CanvasDraw
            ref={(canvasDraw) => {
              this.saveableCanvas = canvasDraw;
              applyPainMapDotFix(canvasDraw);
            }}
            enablePanAndZoom
            clampLinesToDocument
            brushRadius={6}
            lazyRadius={0}
            canvasWidth={600}
            canvasHeight={245}
            brushColor={this.state.brushColor}
            imgSrc={painMapGif}
            saveData={savedData}
            zoomExtents={{ min: 1, max: 2 }}
            disabled={this.props.readOnly}
          />
        </PainMapCanvas>
      </div>
    );
  }
}

export default PainMap;
